import styled from 'styled-components';

export const StyledBlockGroup = styled.section`
  margin-bottom: 16px;
  box-shadow: ${({ theme }) => theme?.Block?.boxShadow};
  
  &:last-child {
    margin-bottom: 0;
  }
`;
